import moment from "moment";

const formataData = (valor, formato = "YYYY-MM-DD") => {
  const format_1 = formato === "YYYY-MM-DD" ? "DD/MM/YYYY" : "YYYY-MM-DD";
  const format_2 = formato === "YYYY-MM-DD" ? "YYYY-MM-DD" : "DD/MM/YYYY";

  return valor ? moment(valor, format_1).format(format_2) : null;
};

const valorNumerico = valor => {
  return valor ? valor.replace(/\D/g, "") : null;
};

export { formataData, valorNumerico };
